import request from '@/utils/request'

export function verifyPassword(data) {
  return request({
    url: '/api/auth/verifyPassword/' + data,
    method: 'get'
  })
}

export function codeFlag(data) {
  return request({
    url: '/api/auth/verifyPassword/code/' + data,
    method: 'get'
  })
}

// 查询总报关单数据
export function queryTotalCustomsDeclaration(data) {
  return request({
    url: '/api/auth/verifyPassword/queryTotalCustomsDeclaration',
    method: 'post',
    data
  })
}

// 查询企业明细数据
export function queryEnterpriseDetails(data) {
  return request({
    url: '/api/auth/verifyPassword/queryEnterpriseDetails',
    method: 'post',
    data
  })
}
